export default __webpack_public_path__ + "static/media/ig.fb85c599.png";